<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('nivels')">Nivel </inertia-link>
      <span class="text-white font-medium">/   {{ form.name}}
      </span>
    </h1>
    <trashed-message v-if="nivel.status==0" class="mb-6" @restore="restore">
     Nivel  Eliminado!
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" required/>
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Activo">
            <option value="1">SI</option>
            <option value="0">NO</option>
            <option>Asesor</option>
          </select-input>
          <text-input v-model="form.description" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-6/6" label="Descripción"/>
          
       </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button v-if="nivel.status==1" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    nivel: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.nivel.name,
        description: this.nivel.description,
        status: this.nivel.status,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('nivels.update', this.nivel.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('nivels.destroy', this.nivel.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('nivels.restore', this.nivel.id))
      }
    },
  },
}
</script>
